import BaseClient from '@/app/model/api/response/baseApiClient'

class MachineMaintenanceListApi extends BaseClient {
  public getMachineMaintenanceList (id: string) {
    const path = '/v1/machine-maintenances'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({ machine_id: id })

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new MachineMaintenanceListApi()
